// extracted by mini-css-extract-plugin
export default {"problem_card_container":"APICard_problem_card_container__K011F","label":"APICard_label__TzYwM","readhide":"APICard_readhide__SeSF4","contribute":"APICard_contribute__SVALi"};